/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { animate, style, transition, trigger } from "@angular/animations";
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from "@angular/core";
import { RGB_COLORS } from "@app/constants/colors.const";

@Component({
	selector: "cb-user-cursor",

	imports: [],
	templateUrl: "./user-cursor.component.html",
	styleUrl: "./user-cursor.component.scss",
	animations: [
		trigger("cursorAnimation", [
			transition(":enter", [
				style({ transform: "scale(0.3)" }),
				animate(
					"300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)",
					style({ transform: "scale(1)" }),
				),
			]),
			transition(":leave", [
				style({ transform: "scale(1)", opacity: 1 }),
				animate(
					"300ms cubic-bezier(0.8, -0.8, 0.2, 1)",
					style({ transform: "scale(0.3)", opacity: 0 }),
				),
			]),
		]),
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCursorComponent {
	private readonly colors_list = RGB_COLORS;

	public readonly x = input<number>();
	public readonly y = input<number>();
	public readonly isPreview = input(false);
	public readonly username = input.required<string>();

	public readonly onDestroy = output<void>();

	public destroying = signal(false);
	public currentColor = computed(() => {
		const username = this.username();

		const hash = username
			.trim()
			.split("")
			.reduce((acc, char) => acc + char.charCodeAt(0), 0);
		return this.colors_list[hash % this.colors_list.length];
	});


	public remove(): void {
		this.destroying.set(true);
		setTimeout(() => this.onDestroy.emit(), 300);
	}
}
